<template>
    <div>
        <top-hero :heroImage="heroImage" :heroTitle="title"></top-hero>
        <!-- About -->
        <div class="mb-5 container-fluid">
            <div class="row d-flex align-items-stretch flex-section">
                <div class="col-md-6 text">
                    <div class="card-body">
                        <small class="primary-color">WHAT WE DO</small>
                        <h2 class="mb-3 primary-color header-text mb-4">About M&O law firm</h2>
                        <p v-html="about.content"></p>
                    </div>
                </div>
                <div class="d-none d-md-block col-md-6 image" :style="{backgroundImage: 'url('+ aboutImg +')'}"></div>

            </div>

            <div class="row d-flex align-items-stretch flex-section">
                <div class="d-none d-md-block col-md-6 image" :style="{backgroundImage: 'url('+ aboutImg2 +')'}"></div>

                <div class="col-md-6 text">
                    <div class="card-body">
                        <h2 class="mb-3 primary-color header-text mb-4">Our Mission</h2>
                        <p v-html="story.content"></p>
                    </div>
                </div>
            </div>

        </div>

        <div class="principles mb-5 mt-md-5 pt-md-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center mb-5">
                        <small class="primary-color">WHAT MAKES US DIFFERENT</small>
                        <h1 class="mb-3 primary-color header-text mb-4">Our Core Principles</h1>
                    </div>
                </div>

                <div class="row principles-container">
                    <principle v-for="(principle, i) in principles" :key="i"
                        :title="principle.title"
                        :icon="principle.icon"
                        :content="principle.content"
                    />
                </div>

            </div>
        </div>

        <div class="consultation">
            <div class="row no-gutters consult">
                <div class="col-md-6">
                    <div class="greetingsBg" :style="{backgroundImage: 'url('+greetingsImage+')'}"></div>
                </div>

                <div class="col-md-6">
                    <div class="left-contact left-bg px-7 py-7">
                        <div class="text-center text-white mb-4">
                            <small>DON’T HESITATE TO ASK</small>
                            <h1 class="header-text">Request a Free Consultation</h1>
                            <p>We are passionate about providing quality services, customized to each client’s individual needs.</p>
                        </div>
                        <contact-form purpose="free-consultation"></contact-form>
                    </div>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
let heroImage = require('@/assets/img/hero/about.jpg');
let aboutImg = require('@/assets/img/about/about1.jpg');
let about2 = require('@/assets/img/about/about2.jpg');
let greetingsImage = require('@/assets/img/about/greetings.jpg');

//Icons
let intergrity = require('@/assets/icons/integrity.svg');

import TopHero from '@/components/frontend/Hero.vue';
import Principle from '@/components/frontend/about/Principle.vue';
import ContactForm from '@/components/ContactForm.vue';
import axios from 'axios';

import { principles } from '@/assets/js/exports.js';

export default {
    components: {
        TopHero: TopHero,
        Principle: Principle,
        ContactForm: ContactForm
    },
    name: 'About',
    data() {
        return {
            heroImage: heroImage,
            aboutImg: aboutImg,
            aboutImg2: about2,
            greetingsImage: greetingsImage,
            title: 'About Us',
            about: '',
            story: '',
            contentLoaded: false,
            principles: principles,
            intergrity: intergrity
        };
    },
    metaInfo() {
        return {
            title: this.title
        };
    },
    methods: {
        fetchAboutData() {
            axios
                .get(APIURL + 'about')
                .then(response => {
                    let res = response.data;
                    this.about = res.about;
                    this.story = res.story;
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    created() {
        this.fetchAboutData();
    }
};
</script>



// WEBPACK FOOTER //
// src/views/frontend/About.vue